import { supabase } from "@/integrations/supabase/client";
import type { Tables, TablesInsert } from "@/integrations/supabase/types";

export type KnowledgeBaseResponse = Tables<"knowledge_base_responses">;
export type KnowledgeBaseResponseInsert = TablesInsert<"knowledge_base_responses">;

export const getKnowledgeBaseResponse = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from("knowledge_base_responses")
      .select("*")
      .eq("user_id", userId)
      .maybeSingle();

    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error("Error fetching knowledge base response:", error);
    return { success: false, error };
  }
};

export const upsertKnowledgeBaseResponse = async (
  userId: string,
  response: Partial<KnowledgeBaseResponse>
) => {
  try {
    const { data, error } = await supabase
      .from("knowledge_base_responses")
      .upsert(
        { ...response, user_id: userId },
        { onConflict: "user_id" }
      )
      .select()
      .single();

    if (error) throw error;

    // Call edge function to sync to webhook (fire and forget)
    supabase.functions.invoke('knowledge-base-sync', {
      body: {
        user_id: userId,
        knowledge_base_data: data
      }
    }).catch((err) => {
      console.error('Error calling knowledge-base-sync edge function:', err);
    });

    return { success: true, data };
  } catch (error) {
    console.error("Error upserting knowledge base response:", error);
    return { success: false, error };
  }
};
